module.exports = __webpack_public_path__ + "static/media/appstore-2c.e3538b1e.png";